"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerType = void 0;
var PartnerType;
(function (PartnerType) {
    PartnerType[PartnerType["Mews"] = 0] = "Mews";
    PartnerType[PartnerType["Referral"] = 1] = "Referral";
})(PartnerType || (exports.PartnerType = PartnerType = {}));
//# sourceMappingURL=PartnerType.js.map